import { createFileRoute, Navigate } from "@tanstack/react-router";
import { Dashboard } from "#app/widgets/dashboards/dashboard";
import { useWorkflowId } from "#app/lib/hooks/use-workflow-id";
import { useViews } from "#app/lib/views/view-context";
import { routePath } from "#app/lib/hooks/use-app-navigate";
import { useRecordDashboardVisit } from "#app/components/dashboards/use-recent-dashboards";

/**
 * `/workflow/$workflowId/dashboard` — the workflow dashboard, scoped to one
 * workflow.
 */
function WorkflowDashboardRoute() {
  const { workspace } = Route.useParams();
  const workflowId = useWorkflowId();
  const { activeView, activeViewGone } = useViews();
  useRecordDashboardVisit("workflow", workflowId, activeView);
  if (!workflowId) return null;
  // A deleted view's URL outlives it — in a bookmark, another browser tab,
  // `preferences.defaultRoute`. Land on the workflow, which resolves
  // whichever view is the default now. Only a loaded, NON-EMPTY row can say
  // deleted: an empty row (a failed load, an unseeded scope) renders this
  // built-in's body as the floor, and while the row is in flight the body
  // renders rather than a spinner — the built-in almost always exists.
  if (activeViewGone) {
    return (
      <Navigate
        to={routePath(`/${workspace}/workflow/${workflowId}`)}
        replace
      />
    );
  }
  return <Dashboard scope={{ kind: "workflow", workflowId }} />;
}

export const Route = createFileRoute(
  "/(app)/$workspace/workflow/$workflowId/dashboard",
)({
  component: WorkflowDashboardRoute,
});
